export default __webpack_public_path__ + "static/timer-2696781def376aee667bf45316d9d8e9.png";